<template>
    <div class="ux-rating" :class="{ 'no-extra-half' : !half, 'editable' : editable }">
        <div v-if="editable" class="star-rating editable" :class="{'has-rating' : temp_value}">
            <label v-for="(rating, index) in ratings" class="star-rating__star" :key="`s${index}`" @click="set(rating)"
                @mouseover="star_over(rating)" @mouseout="star_out" :class="{'is-selected': valueSelected >= rating}">
                <i class="ecom-star prz-product-star"></i>
                <input class="star-rating star-rating__checkbox" type="radio" :value="rating" v-model="valueSelected">
            </label>
        </div>
        <div v-else class="stars-box not-editable" :class="{'has-rating' : value}">
            <i v-for="(star, index) in starts" :key="`s${index}`" :class="icon"></i>
            <i v-if="half" class="ecom-star-half prz-product-star half"></i>
            <i v-if="half" class="ecom-star-half prz-product-star half flip star-remaining"></i>
            <i v-for="(star, index) in remainingStars" :key="`r${index}`" :class="icon" class="star-remaining"></i>
            <span v-if="hasComRatings" class="num-comments"> {{ numComments }} </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Rating',
    props: {
        scale: {
            type: Number,
            default: 5
        },
        value: {
            type: [Number, String],
            default: 0
        },
        // maybe a commentRating object with these 2 fields?
        hasComRatings: {
            type: Boolean,
            default: false
        },
        numComments: {
            type: [Number, String],
            default: '0'
        },
        editable: {
            type: Boolean,
            default: false
        },
        index: {
            type: Number,
            default: 0
        },
        keyClassification: {
            type: String,
            default: ''
        },
        icon:{
            type: String,
            default: 'ecom-star prz-product-star'
        }
    },
    data: function () {
        return {
            temp_value: null,
            ratings: [1, 2, 3, 4, 5],
            valueSelected: {
                type: Number,
                default: 0
            },
        };
    },
    computed: {
        calcValue() {
            const factor = this.scale / 5;
            if(!this.editable && this.temp_value){
                return this.valueSelected / factor;    
            }
            return this.value / factor;
        },
        half() {
            return this.calcValue - Math.floor(this.calcValue) > 0;
        },
        remainingStars() {
            const st = this.starts.length + (this.half ? 1 : 0) + 1
            let stars = [];
            for (let i = st; i <= 5; i++) {
                stars.push(i);
            }
            return stars;
        },
        starts() {
            let stars = [];
            for (let i = 1; i <= this.calcValue; i++) {
                stars.push(i);
            }
            return stars;
        }
    },
    methods: {
        star_over: function (index) {
            this.temp_value = this.valueSelected;
            return this.valueSelected = index;
        },

        /*
         * Behaviour of the stars on mouseout.
         */
        star_out: function () {
            return this.valueSelected = this.temp_value;
        },

        /*
         * Set the rating.
         */
        set: function (value) {    
            this.temp_value = value;
            this.$emit('selected',this.index,value,this.keyClassification);
            return this.valueSelected = value;
        }
    },
}
</script>
<style lang="scss" scoped>
.ux-rating .stars-box{
    display: flex;
    align-items: center;
}
</style>